import { ReviewsSection } from '~/components/Sections'

export default function ReviewsPage() {
  return (
    <main>
      <section className="page-hero section-pad muted">
        <div className="container">
          <span className="eyebrow">Client Feedback</span>
          <h1 className="page-hero-title">Reviews</h1>
          <p className="page-hero-desc">
            See what our customers say about VICTORY machines and S.J.S. Technology
            service. Your feedback helps us improve.
          </p>
        </div>
      </section>
      <ReviewsSection />
    </main>
  )
}
